import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { first, map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../../models';

export const roleGuard = (allowedRoles: UserRole[]): CanActivateFn => {
  return (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    const authorize = () => {
      if (!auth.isAuthenticated()) {
        return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
      }

      const role = auth.role();
      return role && allowedRoles.includes(role) ? true : router.createUrlTree(['/']);
    };

    if (auth.isAuthenticated() && auth.role()) return authorize();

    return auth.sessionRestored$.pipe(
      first(),
      map(() => authorize()),
    );
  };
};
